/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as LoginRouteImport } from './routes/login'
import { Route as SecureRouteImport } from './routes/_secure'
import { Route as SecureIndexRouteImport } from './routes/_secure/index'
import { Route as AcceptTokenRouteImport } from './routes/accept.$token'
import { Route as SecureSubscriptionRouteImport } from './routes/_secure/subscription'
import { Route as SecureSettingsRouteImport } from './routes/_secure/settings'
import { Route as SecureReportingRouteImport } from './routes/_secure/reporting'
import { Route as SecureOnboardingRouteImport } from './routes/_secure/onboarding'
import { Route as SecureCompaniesRouteImport } from './routes/_secure/companies'
import { Route as SecureDeliveriesIndexRouteImport } from './routes/_secure/deliveries/index'
import { Route as SecureAccountsIndexRouteImport } from './routes/_secure/accounts/index'
import { Route as SecureDeliveriesReferenceRouteImport } from './routes/_secure/deliveries/$reference'
import { Route as SecureAccountsNewRouteImport } from './routes/_secure/accounts/new'
import { Route as SecureAccountsIdRouteImport } from './routes/_secure/accounts/$id'

const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const SecureRoute = SecureRouteImport.update({
  id: '/_secure',
  getParentRoute: () => rootRouteImport,
} as any)
const SecureIndexRoute = SecureIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => SecureRoute,
} as any)
const AcceptTokenRoute = AcceptTokenRouteImport.update({
  id: '/accept/$token',
  path: '/accept/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const SecureSubscriptionRoute = SecureSubscriptionRouteImport.update({
  id: '/subscription',
  path: '/subscription',
  getParentRoute: () => SecureRoute,
} as any)
const SecureSettingsRoute = SecureSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => SecureRoute,
} as any)
const SecureReportingRoute = SecureReportingRouteImport.update({
  id: '/reporting',
  path: '/reporting',
  getParentRoute: () => SecureRoute,
} as any)
const SecureOnboardingRoute = SecureOnboardingRouteImport.update({
  id: '/onboarding',
  path: '/onboarding',
  getParentRoute: () => SecureRoute,
} as any)
const SecureCompaniesRoute = SecureCompaniesRouteImport.update({
  id: '/companies',
  path: '/companies',
  getParentRoute: () => SecureRoute,
} as any)
const SecureDeliveriesIndexRoute = SecureDeliveriesIndexRouteImport.update({
  id: '/deliveries/',
  path: '/deliveries/',
  getParentRoute: () => SecureRoute,
} as any)
const SecureAccountsIndexRoute = SecureAccountsIndexRouteImport.update({
  id: '/accounts/',
  path: '/accounts/',
  getParentRoute: () => SecureRoute,
} as any)
const SecureDeliveriesReferenceRoute =
  SecureDeliveriesReferenceRouteImport.update({
    id: '/deliveries/$reference',
    path: '/deliveries/$reference',
    getParentRoute: () => SecureRoute,
  } as any)
const SecureAccountsNewRoute = SecureAccountsNewRouteImport.update({
  id: '/accounts/new',
  path: '/accounts/new',
  getParentRoute: () => SecureRoute,
} as any)
const SecureAccountsIdRoute = SecureAccountsIdRouteImport.update({
  id: '/accounts/$id',
  path: '/accounts/$id',
  getParentRoute: () => SecureRoute,
} as any)

export interface FileRoutesByFullPath {
  '/login': typeof LoginRoute
  '/companies': typeof SecureCompaniesRoute
  '/onboarding': typeof SecureOnboardingRoute
  '/reporting': typeof SecureReportingRoute
  '/settings': typeof SecureSettingsRoute
  '/subscription': typeof SecureSubscriptionRoute
  '/accept/$token': typeof AcceptTokenRoute
  '/': typeof SecureIndexRoute
  '/accounts/$id': typeof SecureAccountsIdRoute
  '/accounts/new': typeof SecureAccountsNewRoute
  '/deliveries/$reference': typeof SecureDeliveriesReferenceRoute
  '/accounts': typeof SecureAccountsIndexRoute
  '/deliveries': typeof SecureDeliveriesIndexRoute
}
export interface FileRoutesByTo {
  '/login': typeof LoginRoute
  '/companies': typeof SecureCompaniesRoute
  '/onboarding': typeof SecureOnboardingRoute
  '/reporting': typeof SecureReportingRoute
  '/settings': typeof SecureSettingsRoute
  '/subscription': typeof SecureSubscriptionRoute
  '/accept/$token': typeof AcceptTokenRoute
  '/': typeof SecureIndexRoute
  '/accounts/$id': typeof SecureAccountsIdRoute
  '/accounts/new': typeof SecureAccountsNewRoute
  '/deliveries/$reference': typeof SecureDeliveriesReferenceRoute
  '/accounts': typeof SecureAccountsIndexRoute
  '/deliveries': typeof SecureDeliveriesIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_secure': typeof SecureRouteWithChildren
  '/login': typeof LoginRoute
  '/_secure/companies': typeof SecureCompaniesRoute
  '/_secure/onboarding': typeof SecureOnboardingRoute
  '/_secure/reporting': typeof SecureReportingRoute
  '/_secure/settings': typeof SecureSettingsRoute
  '/_secure/subscription': typeof SecureSubscriptionRoute
  '/accept/$token': typeof AcceptTokenRoute
  '/_secure/': typeof SecureIndexRoute
  '/_secure/accounts/$id': typeof SecureAccountsIdRoute
  '/_secure/accounts/new': typeof SecureAccountsNewRoute
  '/_secure/deliveries/$reference': typeof SecureDeliveriesReferenceRoute
  '/_secure/accounts/': typeof SecureAccountsIndexRoute
  '/_secure/deliveries/': typeof SecureDeliveriesIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/login'
    | '/companies'
    | '/onboarding'
    | '/reporting'
    | '/settings'
    | '/subscription'
    | '/accept/$token'
    | '/'
    | '/accounts/$id'
    | '/accounts/new'
    | '/deliveries/$reference'
    | '/accounts'
    | '/deliveries'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/login'
    | '/companies'
    | '/onboarding'
    | '/reporting'
    | '/settings'
    | '/subscription'
    | '/accept/$token'
    | '/'
    | '/accounts/$id'
    | '/accounts/new'
    | '/deliveries/$reference'
    | '/accounts'
    | '/deliveries'
  id:
    | '__root__'
    | '/_secure'
    | '/login'
    | '/_secure/companies'
    | '/_secure/onboarding'
    | '/_secure/reporting'
    | '/_secure/settings'
    | '/_secure/subscription'
    | '/accept/$token'
    | '/_secure/'
    | '/_secure/accounts/$id'
    | '/_secure/accounts/new'
    | '/_secure/deliveries/$reference'
    | '/_secure/accounts/'
    | '/_secure/deliveries/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  SecureRoute: typeof SecureRouteWithChildren
  LoginRoute: typeof LoginRoute
  AcceptTokenRoute: typeof AcceptTokenRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_secure': {
      id: '/_secure'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof SecureRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_secure/': {
      id: '/_secure/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof SecureIndexRouteImport
      parentRoute: typeof SecureRoute
    }
    '/accept/$token': {
      id: '/accept/$token'
      path: '/accept/$token'
      fullPath: '/accept/$token'
      preLoaderRoute: typeof AcceptTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_secure/subscription': {
      id: '/_secure/subscription'
      path: '/subscription'
      fullPath: '/subscription'
      preLoaderRoute: typeof SecureSubscriptionRouteImport
      parentRoute: typeof SecureRoute
    }
    '/_secure/settings': {
      id: '/_secure/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof SecureSettingsRouteImport
      parentRoute: typeof SecureRoute
    }
    '/_secure/reporting': {
      id: '/_secure/reporting'
      path: '/reporting'
      fullPath: '/reporting'
      preLoaderRoute: typeof SecureReportingRouteImport
      parentRoute: typeof SecureRoute
    }
    '/_secure/onboarding': {
      id: '/_secure/onboarding'
      path: '/onboarding'
      fullPath: '/onboarding'
      preLoaderRoute: typeof SecureOnboardingRouteImport
      parentRoute: typeof SecureRoute
    }
    '/_secure/companies': {
      id: '/_secure/companies'
      path: '/companies'
      fullPath: '/companies'
      preLoaderRoute: typeof SecureCompaniesRouteImport
      parentRoute: typeof SecureRoute
    }
    '/_secure/deliveries/': {
      id: '/_secure/deliveries/'
      path: '/deliveries'
      fullPath: '/deliveries'
      preLoaderRoute: typeof SecureDeliveriesIndexRouteImport
      parentRoute: typeof SecureRoute
    }
    '/_secure/accounts/': {
      id: '/_secure/accounts/'
      path: '/accounts'
      fullPath: '/accounts'
      preLoaderRoute: typeof SecureAccountsIndexRouteImport
      parentRoute: typeof SecureRoute
    }
    '/_secure/deliveries/$reference': {
      id: '/_secure/deliveries/$reference'
      path: '/deliveries/$reference'
      fullPath: '/deliveries/$reference'
      preLoaderRoute: typeof SecureDeliveriesReferenceRouteImport
      parentRoute: typeof SecureRoute
    }
    '/_secure/accounts/new': {
      id: '/_secure/accounts/new'
      path: '/accounts/new'
      fullPath: '/accounts/new'
      preLoaderRoute: typeof SecureAccountsNewRouteImport
      parentRoute: typeof SecureRoute
    }
    '/_secure/accounts/$id': {
      id: '/_secure/accounts/$id'
      path: '/accounts/$id'
      fullPath: '/accounts/$id'
      preLoaderRoute: typeof SecureAccountsIdRouteImport
      parentRoute: typeof SecureRoute
    }
  }
}

interface SecureRouteChildren {
  SecureCompaniesRoute: typeof SecureCompaniesRoute
  SecureOnboardingRoute: typeof SecureOnboardingRoute
  SecureReportingRoute: typeof SecureReportingRoute
  SecureSettingsRoute: typeof SecureSettingsRoute
  SecureSubscriptionRoute: typeof SecureSubscriptionRoute
  SecureIndexRoute: typeof SecureIndexRoute
  SecureAccountsIdRoute: typeof SecureAccountsIdRoute
  SecureAccountsNewRoute: typeof SecureAccountsNewRoute
  SecureDeliveriesReferenceRoute: typeof SecureDeliveriesReferenceRoute
  SecureAccountsIndexRoute: typeof SecureAccountsIndexRoute
  SecureDeliveriesIndexRoute: typeof SecureDeliveriesIndexRoute
}

const SecureRouteChildren: SecureRouteChildren = {
  SecureCompaniesRoute: SecureCompaniesRoute,
  SecureOnboardingRoute: SecureOnboardingRoute,
  SecureReportingRoute: SecureReportingRoute,
  SecureSettingsRoute: SecureSettingsRoute,
  SecureSubscriptionRoute: SecureSubscriptionRoute,
  SecureIndexRoute: SecureIndexRoute,
  SecureAccountsIdRoute: SecureAccountsIdRoute,
  SecureAccountsNewRoute: SecureAccountsNewRoute,
  SecureDeliveriesReferenceRoute: SecureDeliveriesReferenceRoute,
  SecureAccountsIndexRoute: SecureAccountsIndexRoute,
  SecureDeliveriesIndexRoute: SecureDeliveriesIndexRoute,
}

const SecureRouteWithChildren =
  SecureRoute._addFileChildren(SecureRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  SecureRoute: SecureRouteWithChildren,
  LoginRoute: LoginRoute,
  AcceptTokenRoute: AcceptTokenRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
